export default __webpack_public_path__ + "static/media/cer1.a52d4616.png";